import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { submitSmsDetails } from "../../../../../api/Api";
import { getFromLocalStorage } from "../../../../../utils/common-utils";
import "../smsTabs.css";

const EditSms = ({ editData, onUpdate }) => {
  const [smsData, setSmsData] = useState({
    lowSubscriptionMsg: "",
    lowSubscriptionMsgArabic: "",
    freeTrialMsg: "",
    freeTrialMsgArabic: "",
    chargingMessage: "",
    chargingMessageArabic: "",
  });

  useEffect(() => {
    if (editData) {
      setSmsData(prev => ({
        ...prev,
        ...editData
      }));
    }
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSmsData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    // if (!smsData.lowSubscriptionMsg || !smsData.lowSubscriptionMsgArabic ||
    //     !smsData.freeTrialMsg || !smsData.freeTrialMsgArabic ||
    //     !smsData.chargingMessage || !smsData.chargingMessageArabic) {
    //   Swal.fire({
    //     icon: "error",
    //     text: "Please fill in all required fields",
    //   });
    //   return;
    // }

    try {
      const payload = {
        id: editData?.id,
        userId: getFromLocalStorage("userData")?.id,
        chargingMessage: smsData.chargingMessage,
        chargingMessageArabic: smsData.chargingMessageArabic,
        lowSubscriptionMsg: smsData.lowSubscriptionMsg,
        lowSubscriptionMsgArabic: smsData.lowSubscriptionMsgArabic,
        freeTrialMsg: smsData.freeTrialMsg,
        freeTrialMsgArabic: smsData.freeTrialMsgArabic,
      };

      const response = await submitSmsDetails(payload);

      if (response?.statusDescription?.status === 200) {
        onUpdate(response.productModel);
        Swal.fire({
          icon: "success",
          text: response?.statusDescription?.description || "SMS details updated successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          text: response?.statusDescription?.description || "Failed to update SMS details",
        });
      }
    } catch (error) {
      console.error("Error updating SMS details:", error);
      Swal.fire({
        icon: "error",
        text: "Failed to update SMS details",
      });
    }
  };

  return (
    <div className="tab-content-section">
      <div className="tab-content">
        <div className="tab-pane active">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Low Balance Message
                  </label>
                  <textarea
                    className="form-control"
                    name="lowSubscriptionMsg"
                    value={smsData.lowSubscriptionMsg}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Enter Low Balance Message"
                    dir="ltr"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Low Balance Arabic
                  </label>
                  <textarea
                    className="form-control arabic-input"
                    name="lowSubscriptionMsgArabic"
                    value={smsData.lowSubscriptionMsgArabic}
                    onChange={handleChange}
                    rows="3"
                    placeholder="أدخل رسالة الرصيد المنخفض"
                    dir="rtl"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Free Trial
                  </label>
                  <textarea
                    className="form-control"
                    name="freeTrialMsg"
                    value={smsData.freeTrialMsg}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Enter Free Trial Message"
                    dir="ltr"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Free Trial Arabic
                  </label>
                  <textarea
                    className="form-control arabic-input"
                    name="freeTrialMsgArabic"
                    value={smsData.freeTrialMsgArabic}
                    onChange={handleChange}
                    rows="3"
                    placeholder="أدخل رسالة الفترة التجريبية المجانية"
                    dir="rtl"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Charging
                  </label>
                  <textarea
                    className="form-control"
                    name="chargingMessage"
                    value={smsData.chargingMessage}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Enter Charging Message"
                    dir="ltr"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Charging Arabic
                  </label>
                  <textarea
                    className="form-control arabic-input"
                    name="chargingMessageArabic"
                    value={smsData.chargingMessageArabic}
                    onChange={handleChange}
                    rows="3"
                    placeholder="أدخل رسالة الشحن"
                    dir="rtl"
                    maxLength={500}
                    // required
                  />
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-12  buttons_divs">
                <button
                  type="submit"
                  className="btn btn-primary float-right"
                >
                  Update SMS Details
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditSms;

